import { render, staticRenderFns } from "./RealEstateSummaryModal.vue?vue&type=template&id=48ff884f&"
import script from "./RealEstateSummaryModal.vue?vue&type=script&lang=js&"
export * from "./RealEstateSummaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports